import React from "react"

export default function StaticChart({
  title,
  subTitle,
  figureNumber,
  caption,
  source,
  paddingbottom,
  children,
  ariaLabel,
  classes,
  scaling,
}) {
  const formatSource = text => {
    let formattedText = text.split("/n").map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      )
    })

    return formattedText
  }

  return (
    <div
      className={
        classes ? `chart chart--static ${classes}` : `chart chart--static`
      }
    >
      {figureNumber && (
        <div className="chart__figure-number">Figure {figureNumber}</div>
      )}
      {title && <h3 className="chart__title">{title}</h3>}
      {subTitle &&
        (title ? (
          <h4 className="chart__sub-title">{subTitle}</h4>
        ) : (
          <h3 className="chart__sub-title">{subTitle}</h3>
        ))}

      <figure aria-label={ariaLabel}>
        {scaling === false ? (
          <div className="chart__chart">{children}</div>
        ) : (
          <div
            className="chart__chart scaling-svg-container"
            style={{
              paddingBottom: paddingbottom,
            }}
          >
            {children}
          </div>
        )}
        {caption || source ? (
          <figcaption>
            {caption && <p className="chart__caption">{caption}</p>}
            {source && (
              <p
                className="chart__source"
                dangerouslySetInnerHTML={{ __html: source }}
              />
            )}
          </figcaption>
        ) : null}
      </figure>
    </div>
  )
}
